import {
  SIGN_UP_REQUEST,
  SIGN_UP_RESET,
  SIGN_UP_ERROR_RESET,
  CHECK_TOKEN,
  FROM_ADVERTISE,
  CLEAR_ADVERTISE_INFO,
  UPDATE_FIRST_LOGIN_REQUEST,
} from "../../../modules/constants";

// ------------------------------------
// Actions
// ------------------------------------
export function signUp(value) {
  return {
    type: SIGN_UP_REQUEST,
    payload: value,
  };
}

export function resetSignUp() {
  return {
    type: SIGN_UP_RESET,
  };
}

export function resetSignUpError() {
  return {
    type: SIGN_UP_ERROR_RESET,
  };
}

export function checkToken() {
  return {
    type: CHECK_TOKEN,
  };
}

export function fromAdvertise(value) {
  return {
    type: FROM_ADVERTISE,
    payload: value,
  };
}

export function clearAdvertiseInfo(value) {
  return {
    type: CLEAR_ADVERTISE_INFO,
    payload: value,
  };
}

export function updateFirstLogin() {
  return {
    type: UPDATE_FIRST_LOGIN_REQUEST,
  };
}
